module.exports = __webpack_public_path__ + "img/groups33.e3eabd9d.svg";